import request from '@/utils/request';

export function queryGiftCardPageList(data) {
  return request({
    url: '/gift/card/queryGiftCardPageList',
    method: 'POST',
    data
  });
}
// 键删除礼品卡管理
export function removeGiftCardById(data) {
  return request({
    url: '/gift/card/removeGiftCardById',
    method: 'POST',
    data
  });
}
// 新增礼品卡管理
export function saveGiftCard(data) {
  return request({
    url: '/gift/card/saveGiftCard',
    method: 'POST',
    data
  });
}
// 修改礼品卡管理
export function updateGiftCard(data) {
  return request({
    url: '/gift/card/updateGiftCard',
    method: 'POST',
    data
  });
}
// 获取礼品卡明细
export function fetchGiftCardDetailById(data) {
  return request({
    url: '/gift/card/fetchGiftCardDetailById',
    method: 'POST',
    data
  });
}
// 礼品卡—库存变更记录列表
export function queryGiftCardStockLogPageList(data) {
  return request({
    url: '/gift/card/stock/log/queryGiftCardStockLogPageList',
    method: 'POST',
    data
  });
}
// 获取礼品卡—库存变更-当前库存量
export function queryGifCardStockNumber(data) {
  return request({
    url: '/gift/card/stock/log/queryGifCardStockNumber',
    method: 'POST',
    data
  });
}
// 礼品卡—库存变更记录-添加库存
export function addGiftCardStock(data) {
  return request({
    url: '/gift/card/stock/log/addGiftCardStock',
    method: 'POST',
    data
  });
}
// 礼品卡—库存变更记录-减少库存
export function subtractGiftCardStock(data) {
  return request({
    url: '/gift/card/stock/log/subtractGiftCardStock',
    method: 'POST',
    data
  });
}
// 礼品卡-卡组管理-获取卡组列表
export function queryGiftCardDeckPageList(data) {
  return request({
    url: '/gift/card/deck/queryGiftCardDeckPageList',
    method: 'POST',
    data
  });
}
// 礼品卡-卡组管理-创建卡组
export function saveGiftCardDeck(data) {
  return request({
    url: '/gift/card/deck/saveGiftCardDeck',
    method: 'POST',
    data
  });
}
// 礼品卡-卡组管理-全部激活
export function activeCardMine(data) {
  return request({
    url: '/gift/card/deck/activeCardMine',
    method: 'POST',
    data
  });
}
// 礼品卡-卡组管理-全部作废
export function cancelCardMine(data) {
  return request({
    url: '/gift/card/deck/cancelCardMine',
    method: 'POST',
    data
  });
}
// 获取礼品卡-卡密列表（查看卡组）
export function queryGiftCardMinePageList(data) {
  return request({
    url: '/gift/card/deck/queryGiftCardMinePageList ',
    method: 'POST',
    data
  });
}
// 批量激活（只会激活未使用且未激活的）
export function activeBatchCardMine(data) {
  return request({
    url: '/gift/card/deck/activeBatchCardMine',
    method: 'POST',
    data
  });
}
// 批量作废（不会作废已使用的）
export function cancelBatchCardMine(data) {
  return request({
    url: '/gift/card/deck/cancelBatchCardMine',
    method: 'POST',
    data
  });
}
// 导出Excel
export function exportExcel(data) {
  return request({
    url: '/gift/card/deck/exportExcel',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}
// 获取卡密记录列表
export function queryGiftCardOrderMinePageList(data) {
  return request({
    url: '/gift/card/deck/queryGiftCardOrderMinePageList',
    method: 'POST',
    data
  });
}
// 获取礼品卡-订单信息表列表
export function queryGiftCardOrderPageList(data) {
  return request({
    url: '/gift/card/order/queryGiftCardOrderPageList',
    method: 'POST',
    data
  });
}
// 根据订单或获取礼品卡-订单信息表详情
export function fetchGiftCardOrderDetail(data) {
  return request({
    url: '/gift/card/order/fetchGiftCardOrderDetail',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/giftCard.js